module.exports = __webpack_public_path__ + "static/media/white_logo_iitgoa.2e4259b9.webp";